var map = {
	"./discord.svg": 2146,
	"./evernote.svg": 2442,
	"./facebook.svg": 1378,
	"./gmail.svg": 808,
	"./google_docs.svg": 935,
	"./google_sheets.svg": 8374,
	"./linkedin.svg": 3816,
	"./microsoft_word.svg": 6105,
	"./outlook.svg": 1431,
	"./reddit.svg": 9646,
	"./salesforce.svg": 2887,
	"./slack.svg": 4342,
	"./twitter.svg": 2799,
	"./whatsapp.svg": 7792,
	"./youtube.svg": 5797
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9832;